import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const InputPhone = ({ value, onChange, onBlur, disabled, defaultCountry = 'OM', placeholder, id, inputClassName = '', className = 'w-full' }) => (
  <PhoneInput
    disabled={!!disabled}
    defaultCountry={defaultCountry}
    international
    countryCallingCodeEditable
    placeholder={placeholder || 'Enter phone number'}
    value={value}
    onChange={onChange}
    className={className}
    numberInputProps={{ className: inputClassName, id, onBlur }}
  />
)

export default InputPhone
